// MainMenu.js

import React from "react";
import { useEffect, useState } from "react";
import { Pressable, Text, View } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";  // https://fontawesome.com/search?ic=free-collection
import { faUser, faPaw } from "@fortawesome/free-solid-svg-icons";
// import { } from "@fortawesome/free-regular-svg-icons";
import { triggerAlert } from "components/Partials/AlertModal";
import appviews from "components/helpers/appviews";

const MainMenu = function () {
  const _theme = window.main.theme;
  const _current_view = window.main.lib.getCurrentView();
  const [openState, setOpenState] = useState(false);
  const toggleMenu = ()=>{
    const _prevStat = openState;
    window.main.onClickMainBody();  // ⬅ Closes any other open Menus...
    setOpenState(!_prevStat);
    locationsSubmenuOpenSetState(false);
  };
  const closeMainMenu = ()=>{
    setOpenState(false);
    locationsSubmenuOpenSetState(false);
  };
  // const toggleDarkMode = ()=>{
  // 	window.main.lib.setScreenState({ currentDarkTheme: !window.main.lib.screenState.currentDarkTheme });
  // 	setOpenState(false);
  // };

  const userProfile = window.main.lib.getUserProfile();
  const [locationsSubmenuOpenState, locationsSubmenuOpenSetState] = useState(false);
  const toggleLocationsSubmenu = ()=>{
    locationsSubmenuOpenSetState(s=>(!s));
  };
  const onClickChangeLocation = async (sel_location_id)=>{
    window.main.lib.setLoadingState(true);
    closeMainMenu();
    try {
      await window.main.axios.post(window.main.api.changeLocation.replace("{location_id}",sel_location_id));  // Non-200 response status throw error - handled in catch(err).
      userProfile.current_location = userProfile.locations.find(o=>(o.location_id===sel_location_id));
      window.main.lib.setUserProfile(userProfile);
      window.main.lib.setLoadingState(false);
    } catch (err) {
      console.log(err);
      triggerAlert({
        show: true,
        title: "Error",
        message: "There was an error attempting to change locations.\n\nPlease try again or contact support.",
        onConfirmPressed: triggerAlert,
      });
    }
  };

  useEffect (()=>{
    window.main.addOnClick("MainMenu", closeMainMenu);
    return ()=>{
      window.main.removeOnClick("MainMenu");
    }
  },[]);

  const sharedStyles = MainMenuStyles({openState:openState});

  return (
    <View id="MainMenu" style={{...sharedStyles.menuContainer,...(!openState?{boxShadow:"none",borderBottomWidth:0,borderLeftWidth:0,borderTopWidth:0}:{})}}>
      <Pressable id="menuTitleRow" style={{...sharedStyles.menuRow,...sharedStyles.menuTitleRow}} onPress={toggleMenu}>
        <Feather name="menu" style={{...sharedStyles.menuRowIcon,...sharedStyles.menuTitleRowIcon}} />
        {!!openState &&
          <>
            <Text style={{...sharedStyles.menuRowText,...sharedStyles.menuTitleRowText}}>
              Main Menu
            </Text>
            <Feather name="x" style={{...sharedStyles.menuRowIcon,...sharedStyles.menuTitleRowIcon, position:"absolute", right:(window.main.platform_os==="web"?14:9), top:(window.main.platform_os==="web"?8:8), fontSize:sharedStyles.menuTitleRowIcon.fontSize+4,width:25}} />
          </>
        }
      </Pressable>
      {!!openState &&
        <>
          <Pressable id="MyProfile" key="MyProfile" style={{...sharedStyles.menuRow,zIndex:99,...(_current_view==="profile"?sharedStyles.currentMenuRow:{})}} onPress={()=>{window.main.lib.setCurrentView("profile");closeMainMenu();}}>
            <Feather name="user" size={20} style={{...sharedStyles.menuRowIcon}} />
            <Text style={sharedStyles.menuRowText}>
              {userProfile.first_name} {userProfile.last_name} [{_current_view}]
            </Text>
          </Pressable>
          <Pressable id="locationsSubMenu" key="locationsSubMenu" style={{...sharedStyles.menuRow,zIndex:98}} onPress={toggleLocationsSubmenu}>
            <Feather name="map-pin" size={20} style={{...sharedStyles.menuRowIcon}} />
            <Text style={sharedStyles.menuRowText}>
              Location: {userProfile.current_location.shortname}
              <Feather name="repeat" size={20} style={{...sharedStyles.menuRowIcon,marginLeft:20}} />
            </Text>
            <View style={{...sharedStyles.menuContainer,position:"absolute",top:"100%",right:0,width:"100%",backgroundColor:_theme.colors.opposite_mode.menuBackgroundColor,...(!locationsSubmenuOpenState?{boxShadow:"none"}:{})}}>
              {!!locationsSubmenuOpenState && userProfile.locations.map((locObj)=>{
                if (locObj.location_id===userProfile.current_location.location_id) {
                  return null;
                }
                const onClickSelectLocation = ()=>{
                  onClickChangeLocation(locObj.location_id);
                };
                return (
                  <Pressable id={"locaid_"+locObj.location_id} key={"locaid_"+locObj.location_id} style={{...sharedStyles.menuRow,borderTopWidth:0}} onPress={onClickSelectLocation}>
                    <Feather name="map-pin" size={20} style={{...sharedStyles.menuRowIcon,color:_theme.colors.opposite_mode.menuTextColor}} />
                    <Text style={{...sharedStyles.menuRowText,color:_theme.colors.opposite_mode.menuTextColor}}>
                      {locObj.shortname}
                    </Text>
                  </Pressable>
                );
              })}
            </View>
          </Pressable>
          {appviews.mainMenuKeys.map((linkKey,index)=>{
            const _menuLinkObj = appviews[linkKey];
            const _menuLinkOnClick = ()=>{
              if (!!_menuLinkObj.function) {
                _menuLinkObj.function();
              } else {
                window.main.lib.setCurrentView(linkKey);
              }
              closeMainMenu();
            };
            return (
              <Pressable id={linkKey} key={linkKey} style={{...sharedStyles.menuRow,zIndex:(90-index),...(_current_view===linkKey?sharedStyles.currentMenuRow:{})}} onPress={_menuLinkOnClick}>
                {!!_menuLinkObj.iconSource && _menuLinkObj.iconSource==="fa" &&
                  <FontAwesomeIcon icon={_menuLinkObj.icon} style={{color:_theme.colors.mode.textColor4,height:14,width:14,marginBottom:-1,marginRight:5,marginLeft:-16}} />
                }
                {(!_menuLinkObj.iconSource || _menuLinkObj.iconSource!=="fa") &&
                  <Feather name={_menuLinkObj.icon} size={20} style={{...sharedStyles.menuRowIcon,...(_menuLinkObj.icon==="log-out"?{transform:[{rotate:"180deg"}],marginLeft:-3,marginRight:3}:null)}} />
                }
                <Text style={sharedStyles.menuRowText}>
                  {_menuLinkObj.title}
                </Text>
              </Pressable>
            );
          })}
        </>
      }
      {/* {!!openState &&
        <Pressable style={{...sharedStyles.menuRow}} onPress={toggleDarkMode}>
          <Feather name={!!window.main.lib.screenState.currentDarkTheme?"moon":"sun"} style={{...sharedStyles.menuRowIcon}} />
          <Text style={sharedStyles.menuRowText}>
            Toggle Darkmode {!!window.main.lib.screenState.currentDarkTheme?"Off":"On"}
          </Text>
        </Pressable>
      } */}
    </View>
  );
};

export default MainMenu;

const MainMenuStyles = ({openState})=>{
  const _theme = window.main.theme;
  const sharedStyles = {
    menuContainer: {
      alignItems: "flex-start",
      backgroundColor: (!!openState?_theme.colors.mode.menuBackgroundColor:"transparent"),
      borderBottomLeftRadius: 14,
      // borderBottomWidth: 1,
      borderColor: _theme.colors.mode.menuBorderColor,
      // borderLeftWidth: 1,
      // borderRightWidth: 0,
      borderTopLeftRadius: 14,
      // borderTopWidth: 1,
      boxShadow: "-2px 3px 7px -2px #00000080",
      display: "flex",
      flexDirection: "column",
      fontSize: 0,
      justifyContent: "stretch",
      lineHeight: 0,
      minWidth: (window.main.platform_os==="web"?48:42),  // When Menu is CLOSED, this sets the right-side spacing of the menu icon
      overflow: "hidden",
    },
    menuTitleRow: {
      borderBottomWidth: (!!openState?1:0),
      borderTopWidth: 0,
      height: 40,
      paddingLeft: 10,
      paddingRight: 12,  // When Menu is CLOSED, this sets the right-side spacing of the menu icon
    },
    menuTitleRowIcon: {
      // color: _theme.colors.mode.menuTextColor,
      // color: (!!openState?_theme.colors.mode.menuTextColor:_theme.colors.opposite_mode.menuTextColor),
      color: (!!openState?_theme.colors.mode.menuTextColor:"#ffffff"),
      fontSize: 22,
      height: 24,
      lineHeight: 26,
    },
    menuTitleRowText: {
      fontWeight: "600",
      fontSize: 20,
      marginRight: 40,
    },
    menuRow: {
      alignItems: "center",
      alignSelf: "stretch",
      borderColor: _theme.colors.mode.menuBorderColor,
      borderTopWidth: 1,
      color: _theme.colors.mode.menuTextColor,
      display: "flex",
      flexDirection: "row",
      height: 36,
      justifyContent: "stretch",
      lineHeight: 36,
      paddingBottom: 0,
      paddingLeft: 12,
      paddingRight: 40,
      paddingTop: 0,
      whitespace: "no-wrap",
    },
    currentMenuRow: {
      backgroundColor: _theme.colors.mode.menuBackgroundColorSel,
      color: "red",
    },
    menuRowIcon: {
      color: _theme.colors.mode.menuTextColor,
      fontSize: 18,
      lineHeight: 20,
      height: 20,
      width: 20,
    },
    menuRowText: {
      color: _theme.colors.mode.menuTextColor,
      fontSize: 16,
      lineHeight: 36,
      marginLeft: 15,
    },
  };
  return sharedStyles;
};
